import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";


declare var ko: any;
declare var page: any;

export class networkGroupView_template extends vnTemplate {
    
    protected getTemplateHtml(): string {

        return `
        
            <div class="form-header" data-bind="with: networkGroup">
                <input type="hidden">
                <button class="btn secondary icon i-back" data-bind="click: $parent.onClickBackToList" type="button">back to Network Group list</button>
                <h3 class="form-title icon i-role" data-bind="text: name"></h3>
                <button class="btn secondary icon i-edit" type="button" data-bind="click: $parent.onClickEdit">Edit Network Group</button>
            </div>
            
            <div id="view-results">
            
                 <div data-bind="with: networkGroup">     
                    <div class="w-form-body">
                
                        <div class="form-body">
         
                            <div class="form-group">
                                 <dl class="double-list">              
                                    <dt>
                                        <span>Name</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: name"></span>
                                    </dd>
                                    <dt>
                                        <span>Creation Date</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: dateCreated"></span>
                                    </dd>
                                </dl>
                            </div>
                              
                         </div>
                         <div class="form-body">               
                            
                            <div class="form-group">
                                <legend class="form-legend">Network Categories</legend>
                                <div data-bind="foreach: $parent.networks">
                                    <div class="form-check-inline">
                                        <input type="checkbox" class="read-only" data-bind="attr: {id: 'network_' + id}, value: id, checked: true">
                                        <label class="form-label icon i-check"  data-bind="text: name, attr: {for: 'network_' + id}"></label>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    protected initPartial() {
     }

    /**
     *
     * @protected
     */
    protected getTemplateName(): string {
        return "networkGroupView_template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large", "margin-top", "roles-view"];
    }

    protected buildViewModel(): any {

        let myself = this;
        return {
            idNetworkGroup: ko.observable(""),
            networkGroup: ko.observable(),
            networks: ko.observableArray([]),
            onClickBackToList: function () {
                myself.onClickBackToList();
            },
            onClickEdit: function () {
                myself.onClickEdit();
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest(): Object {

        return {
            idNetworkGroup : this.getTemplateViewModel().idNetworkGroup()
        }
    }

    protected onClickBackToList(): void {

        this.caller.backToList();
    }

    protected onClickEdit(): void {

        this.caller.editNetworkGroup(this.getTemplateViewModel().idNetworkGroup());
    }


    public setNetworkGroup(networkGroup: {id: number, name: string, networks: Array<{id: number, name: string, description: string}>}): void {

        this.getTemplateViewModel().networkGroup(networkGroup);
    }

    /**
     *
     * @param networks
     */
    public setNetworks(networks: Array<{ id: number, name: string, description: string}>): void {

        let allNetworks = [];
        let selectedNetworks = [];
        allNetworks = this.getTemplateViewModel().networkGroup().networks;

        networks.forEach((network) => {
            let isSelected = false;
            allNetworks.forEach((sn) => {
                if (network.id == sn.idNetworkCategory) {
                    isSelected = true;
                }
            });

            if (isSelected) {
                selectedNetworks.push(network);
            }
        });

        this.getTemplateViewModel().networks(selectedNetworks);
    }

    public getNetworkGroup(): void {
        return this.getTemplateViewModel().networkGroup();
    }

    protected onUpdateError(status, data): void {
        console.log('onUpdateError' + status);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/networkGroupView_template.ts